// Fontaine M22 — the ONE status → tone map (Board 1, Q12, Guillaume's call):
// INDIGO active · GREEN sold / paid / done (money landed) · AMBER reserved / pending · GREY in repair / inactive / draft · RED error.
// Every Badge / StatusDot / Chip that shows a business status goes through here so a status looks the same everywhere.

export const TONES = ["accent", "success", "warning", "danger", "muted", "info"];

const MAP = {
  // listings
  active: "accent",
  live: "accent",
  published: "accent",
  sold: "success",
  paid: "success",
  done: "success",
  completed: "success",
  delivered: "success",
  deposited: "success",
  reserved: "warning",
  pending: "warning",
  awaiting: "warning",
  processing: "warning",
  in_repair: "muted",
  repair: "muted",
  inactive: "muted",
  draft: "muted",
  archived: "muted",
  cancelled: "muted",
  consignment: "info",
  // people — a CRM contact's own lifecycle (see Users/Row.jsx `statusMeta`). `active` and
  // `pending` above already cover two of the four; these are the missing pair, added here
  // rather than mapped again at the call site so a person's status matches everywhere.
  invited: "info",
  blocked: "danger",
  error: "danger",
  failed: "danger",
  rejected: "danger",
  overdue: "danger",
};

const norm = (s) => String(s ?? "").trim().toLowerCase().replace(/[\s-]+/g, "_");

/** @returns {"accent"|"success"|"warning"|"danger"|"muted"|"info"} */
export const statusTone = (status) => MAP[norm(status)] || "muted";

/** "in_repair" → "In repair" — sentence case, never ALL CAPS. */
export const statusLabel = (status) => {
  const s = norm(status).replace(/_/g, " ");
  return s ? s.charAt(0).toUpperCase() + s.slice(1) : "";
};
